// Pure helper functions extracted from IdentityTab.tsx.
// These have no dependency on component state/hooks so they can be
// unit tested and reused independently.
/* eslint-disable */
export const formatByNumeric = (input: string): string => {
  try {
    const onlyNumeric: string = input;
    if (input?.length) {
      return onlyNumeric.replace(/\D/g, '');
    }
    return onlyNumeric;
  } catch (error: any) {
    console.log('Error in formatByNumeric: ', error?.message);
    return input;
  }
};

export const formatPhoneNumber = (input: string): string => {
  try {
    let phoneNumber: string = input;
    if (input && input.length > 0) {
      const cleaned = formatByNumeric(input);

      phoneNumber = cleaned.replace(
        /^(?:\+?([0-9]{2,3})[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        '+$1 ($2) $3-$4'
      );
      const match = cleaned.match(
        /^(?:\+?([0-9]{1,3})[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      );

      if (match) {
        const [, cc, area, prefix, line] = match;
        const allowedCodes = ['1', '52', '91'];

        if (!cc || allowedCodes.includes(cc)) {
          phoneNumber = `${cc ? '+' + cc + ' ' : ''}(${area}) ${prefix}-${line}`;
        } else {
          phoneNumber = cleaned; // Return as-is if not allowed
        }
      } else {
        phoneNumber = cleaned; // fallback if not matched
      }
    }
    return phoneNumber;
  } catch (error: any) {
    return input;
  }
};

export const validateNameField = (
  fieldValue: string,
  fieldName: string,
  errors: Record<string, string>,
  keyName?: string
): void => {
  const maxMsg = `Enter a valid ${keyName ?? fieldName}`;

  if (!fieldValue || fieldValue.length < 1) {
    errors[fieldName] = maxMsg;
  }
};

export const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Failed to convert file.'));
    reader.readAsDataURL(file);
  });
};
